import React, { useEffect, useState } from "react";
import formatMoney from "../../../utils/formatMoney";
import revenueByConsu from "../../../utils/revenueByConsu";
import revenueByOverall from "../../../utils/revenueByOverall";
import revenueByPDI from "../../../utils/revenueByPDI";
import revenueByRepair from "../../../utils/revenueByRepair";
import revenueByService from "../../../utils/revenueByService";
import revenueBySublet from "../../../utils/revenueBySublet";
import { REACT_APP_ARPS_BASE_URL } from "../../../utils/urls";
import RevenueConsuPannel from "./RevenueConsuPanel";
import RevenueOthersPannel from "./RevenueOthersPanel";
import RevenuePDISPannel from "./RevenuePDISPanel";
import RevenueRepairsPannel from "./RevenueRepairsPanel";
import RevenueServicesPannel from "./RevenueServicesPanel";
import RevenueSubletsPannel from "./RevenueSubletsPanel";

export default function RevenueBreakdown({ startDate, endDate }: any) {
  const [showServices, setShowServices] = useState(false);
  const [showRepairs, setShowRepairs] = useState(false);
  const [showPDIS, setShowPDIS] = useState(false);
  const [showConsu, setShowConsu] = useState(false);
  const [showSublets, setShowSublets] = useState(false);
  const [showOthers, setShowOthers] = useState(false);
  const [repairs, setRepairs] = useState<any>([]);
  const [services, setServices] = useState<any>([]);
  const [pdis, setPDIS] = useState<any>([]);
  const [consumables, setConsumables] = useState<any>([]);
  const [sublets, setSublets] = useState<any>([]);
  const [loading, setLoading] = useState(false);
  const [overall, setOverall] = useState(0);

  const fetchRevenues = async () => {
    setLoading(true);
    const response = await fetch(
      `${REACT_APP_ARPS_BASE_URL}/revenue/workshop/service?start=${startDate}&end=${endDate}`
    );
    const data = await response.json();
    const repairs = revenueByRepair(data);
    const services = revenueByService(data);
    const pdis = revenueByPDI(data);
    const consumables = revenueByConsu(data);
    const sublets = revenueBySublet(data);
    const overall = revenueByOverall(data);

    setRepairs(repairs);
    setServices(services);
    setPDIS(pdis);
    setConsumables(consumables);
    setSublets(sublets);
    setLoading(false);
    setOverall(overall);
  };

  useEffect(() => {
    fetchRevenues();
  }, [startDate]);

  const serTotal = isNaN(services?.service?.net) ? 0 : services?.service?.net;
  const repTotal = isNaN(repairs?.repair?.net) ? 0 : repairs?.repair?.net;
  const subTotal = isNaN(sublets?.sublet?.net) ? 0 : sublets?.sublet?.net;
  const pdiTotal = isNaN(pdis?.pdi?.net) ? 0 : pdis?.pdi?.net;
  const conTotal = isNaN(consumables?.consumable?.net)
    ? 0
    : consumables?.consumable?.net;

  const total = serTotal + repTotal + pdiTotal + conTotal;

  const others = overall - total;


  return (
    <div className="flex flex-col justify-center items-start px-4">
      <button
        onClick={() => setShowServices(true)}
        className="flex justify-between items-center border-b py-3 px-2 w-full hover:bg-red-100"
      >
        <div className="">Services Revenue</div>
        <div className="">{formatMoney(serTotal)}</div>
      </button>
      <button
        onClick={() => setShowRepairs(true)}
        className="flex justify-between items-center border-b px-2 py-3 w-full  hover:bg-red-100"
      >
        <div className="">Repairs Revenue</div>
        <div className="">{formatMoney(repTotal)}</div>
      </button>
      <button
        onClick={() => setShowPDIS(true)}
        className="flex justify-between items-center border-b px-2 py-3 w-full  hover:bg-red-100"
      >
        <div className="">P.D.I Revenue</div>
        <div className="">{formatMoney(pdiTotal)}</div>
      </button>

      <button
        onClick={() => setShowSublets(true)}
        className="flex justify-between items-center border-b px-2 py-3 w-full  hover:bg-red-100"
      >
        <div className="">Sublets Revenue</div>
        <div className="">{formatMoney(subTotal)}</div>
      </button>
      <button
        onClick={() => setShowConsu(true)}
        className="flex justify-between items-center border-b px-2 py-3 w-full  hover:bg-red-100"
      >
        <div className="">Adjustment Revenue</div>
        <div className="">{formatMoney(conTotal)}</div>
      </button>
      <button
        onClick={() => setShowOthers(true)}
        className="flex justify-between items-center border-b px-2 py-3 w-full  hover:bg-red-100"
      >
        <div className="">Others</div>
        <div className="">{formatMoney(others)}</div>
      </button>
      <div className="flex justify-between items-center px-2 py-4 border-t border-gray-300 w-full">
        <div className="">Grand Total</div>
        <div className="font-bold">{formatMoney(overall)}</div>
      </div>

      <RevenueServicesPannel
        isVisible={showServices}
        setShowServices={setShowServices}
        services={services}
        startDate={startDate}
        endDate={endDate}
      />

      <RevenueRepairsPannel
        isVisible={showRepairs}
        setShowRepairs={setShowRepairs}
        repairs={repairs}
        startDate={startDate}
        endDate={endDate}
      />

      <RevenuePDISPannel
        isVisible={showPDIS}
        setShowPDIS={setShowPDIS}
        pdis={pdis}
        startDate={startDate}
        endDate={endDate}
      />

      <RevenueConsuPannel
        isVisible={showConsu}
        setShowConsu={setShowConsu}
        consumables={consumables}
        startDate={startDate}
        endDate={endDate}
      />

      <RevenueSubletsPannel
        isVisible={showSublets}
        setShowSublets={setShowSublets}
        sublets={sublets}
        startDate={startDate}
        endDate={endDate}
      />

      <RevenueOthersPannel
        isVisible={showOthers}
        setShowOthers={setShowOthers}
        services={services}
        startDate={startDate}
        endDate={endDate}
        others={others}
      />
    </div>
  );
}
